export default __webpack_public_path__ + "static/media/medical2.3ff790aa.svg";